import '../../scss/acf-blocks/block-account-types.scss';
import { detectCountry, changeCountry } from '../components/detect-country';

const currentCounty = detectCountry() || 'US';

changeCountry(currentCounty);
